export default __webpack_public_path__ + "static/media/xiangchang.622709ad.png";